import React, { useState, useEffect } from 'react'
import Card from '../../components/Card.jsx'
import * as api from '../../services/api.js'

const BINGO_POOL = [
  'Walked outside with no destination', 'Made something with your hands',
  'Watched the sky for a minute', 'Listened to a full song',
  'Drank water mindfully', 'Smiled at a stranger',
  'Tried a new food or drink', 'Sat in silence on purpose',
  'Wrote down one good thing', 'Moved your body gently',
  'Looked at something beautiful', 'Called or messaged someone',
  'Did something just for fun', 'Read a few pages of anything',
  'Cooked or baked something', 'Went somewhere unfamiliar',
  'Rested without guilt', 'Noticed a smell or sound',
  'Spent time in nature', 'Learned one small new thing',
  'Bought yourself a small treat', 'Watched something that made you laugh',
  'Did absolutely nothing for 10 mins', 'Finished something you started',
  'Opened a window for fresh air', 'Stretched for five minutes',
  'Listened to birds or rain', 'Wrote a kind note to yourself',
  'Tried something you have been putting off', 'Ate a meal without a screen',
]

const LINES = [
  [0,1,2,3,4],[5,6,7,8,9],[10,11,12,13,14],[15,16,17,18,19],[20,21,22,23,24],
  [0,5,10,15,20],[1,6,11,16,21],[2,7,12,17,22],[3,8,13,18,23],[4,9,14,19,24],
  [0,6,12,18,24],[4,8,12,16,20],
]

function shuffle(pool) {
  const p = [...pool]
  for (let i = p.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [p[i], p[j]] = [p[j], p[i]]
  }
  const chosen = p.slice(0, 24)
  chosen.splice(12, 0, 'FREE')
  return chosen
}

function hasLine(done)  { return LINES.some(l => l.every(i => done.includes(i))) }
function isFull(done)   { return done.length >= 25 }

export default function JoyBingo() {
  const [state, setState] = useState(null)

  useEffect(() => {
    api.getBingo().then(d => {
      if (d && Array.isArray(d.items) && d.items.length) setState(d)
      else setState({ items: shuffle(BINGO_POOL), done: [12], freeText: '' })
    })
  }, [])

  if (!state) return null

  const { items, done, freeText } = state

  function update(next) {
    setState(next)
    api.saveBingo(next)
  }

  function tick(i) {
    if (items[i] === 'FREE') return
    const newDone = done.includes(i) ? done.filter(d => d !== i) : [...done, i]
    update({ ...state, done: newDone })
  }

  function setFreeText(val) {
    update({ ...state, freeText: val })
  }

  function reset() {
    update({ items: shuffle(BINGO_POOL), done: [12], freeText: '' })
  }

  function regenerate() {
    update({ items: shuffle(BINGO_POOL), done: [12], freeText: state.freeText || '' })
  }

  const completedCount = done.filter(i => items[i] !== 'FREE').length
  const full = isFull(done)
  const line = hasLine(done)

  return (
    <Card label="Joy bingo" title="Tick off small joys">

      {/* Line win message */}
      {!full && line && (
        <div className="bingo-win">Great job! You got a line.</div>
      )}

      {/* Full card complete */}
      {full && (
        <div className="bingo-complete">
          Congratulations! You have finished your bingo card!
        </div>
      )}

      <p className="bingo-progress">{completedCount} of 24 completed</p>

      {/* 5×5 grid */}
      <div className="bingo-grid">
        {items.map((item, i) => {
          const isFreeCell = item === 'FREE'
          const isDone = done.includes(i)

          if (isFreeCell) {
            return (
              <div key={i} className="bingo-cell free">
                <input
                  type="text"
                  placeholder="Your goal..."
                  value={freeText}
                  maxLength={35}
                  onClick={e => e.stopPropagation()}
                  onChange={e => setFreeText(e.target.value)}
                />
              </div>
            )
          }

          return (
            <div
              key={i}
              className={`bingo-cell ${isDone ? 'done' : ''}`}
              onClick={() => tick(i)}
            >
              {item}
            </div>
          )
        })}
      </div>

      {/* Actions */}
      <div className="bingo-actions">
        <button className="ghost-btn" onClick={reset}>New card</button>
        <button className="ghost-btn" onClick={regenerate}>Regenerate</button>
      </div>
    </Card>
  )
}
